export default {
  email: "lovehiitapp@gmail.com",
  envIsDev: true, // TODO Remove this
  appleAppStoreUrl: "https://apps.apple.com/us/app/love-hiit/id1511764271?ls=1",
  googlePlayStoreUrl:
    "https://play.google.com/store/apps/details?id=io.lovehiit.exercise",
};
